// extracted by mini-css-extract-plugin
export default {"main":"LubricantDisposal_main__4lzde","tabContent":"LubricantDisposal_tabContent__o5h2U"};